import { CSSProperties, FunctionComponent, ReactElement } from "react";
import { cn } from "../../utils/cn";

export interface SkeletonWrapperProps {
  className?: string;
  skeletonClassName?: string;
  baseColor?: string;
  count?: number;
}

/**
 *
 */
export const Skeleton: FunctionComponent<SkeletonWrapperProps> = ({
  className,
  skeletonClassName,
  baseColor,
  count,
}) => {
  const css = cn("flex flex-col justify-between", className);

  const elements: ReactElement[] = [];
  for (let i = 0; i < (count || 1); i++) {
    elements.push(
      <div
        key={`skel-${i}`}
        className={cn("cy-skeleton", skeletonClassName)}
        style={{ "--base-color": baseColor } as CSSProperties}
      >
        &zwnj;
      </div>,
    );
  }
  return (
    <span className={css} aria-busy={true} aria-live="polite">
      {elements}
    </span>
  );
};
